const api = '/item-service/api/external/fsku';

export const futureSkusContext = {
  all: api,
  byId: `${api}/{id}`,
  byItem: '/item-service/api/external/items/{id}/fsku',
};
